import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueCountdown from '@chenfengyuan/vue-countdown';
import * as firebase from "firebase"
import router from './router'
import VueSocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false
Vue.component(VueCountdown.name, VueCountdown);

Vue.use(VueSocialSharing);

const firebaseConfig = {
  apiKey: "AIzaSyBkZBJY36Csg1dSWopBEZhceIfSz1zObSY",
  authDomain: "revelacha.firebaseapp.com",
  databaseURL: "https://revelacha.firebaseio.com",
  projectId: "revelacha",
  storageBucket: "revelacha.appspot.com",
  messagingSenderId: "681268845746",
  appId: "1:681268845746:web:47df592430fa858496fdab",
  measurementId: "G-PZYQ3LJC2K"
};

firebase.initializeApp(firebaseConfig);

// console.log("Estou Entrando")
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

export const db = firebase.firestore()
